import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import CalendlyBooking from '../components/CalendlyBooking';
import FaqItem from '../components/FaqItem';
import Button from '../components/Button';
import { company, contactReasons, faqItems, homeImages } from '../data/siteData';
import { scrollToAnchorAfterLayout } from '../utils/scrollToAnchor';

export default function ContactPage() {
  const scrollToBooking = () => {
    const mobileBookingTarget = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(max-width: 640px)').matches
      ? 'booking-recaptcha-gate'
      : 'booking';

    scrollToAnchorAfterLayout(mobileBookingTarget);
  };

  return (
    <>
      <PageHero
        eyebrow="Contact BrainTorch™ Bio"
        title="Get in touch about training, partnerships, or consulting services"
        description="Interested in training, partnerships, consulting services, or BrainTorch™ Launch? Connect with BrainTorch™ Bio to take the next step."
        image={homeImages.partnerships}
        compact
      />

      <section id="contact-connect" className="section shell">
        <div className="contact-grid">
          <div className="contact-card">
            <p className="eyebrow">Get in touch</p>
            <h2>Let’s connect.</h2>
            <p>
              Reach out about BrainTorch™ Launch, STEM education and workforce development, scientific and research consulting, or partnership opportunities.
            </p>
            <div className="button-row top-gap-md">
              <Button variant="teal" onClick={scrollToBooking}>Book a Consultation</Button>
            </div>
            <div className="contact-details">
              <div>
                <strong>Phone</strong>
                <span>{company.phone}</span>
              </div>
              <div>
                <strong>Email</strong>
                <span>{company.email}</span>
              </div>
              <div>
                <strong>Location</strong>
                <span>{company.location}</span>
              </div>
            </div>
          </div>

          <ContactForm reasons={contactReasons} />
        </div>
      </section>

      <CalendlyBooking />

      <section className="section section--contrast">
        <div className="shell faq-grid">
          <div>
            <p className="eyebrow">Frequently Asked Questions</p>
            <h2>Training, career outcomes, and partnership details.</h2>
            <p className="lead-small">
              The contact form captures name, email, organization, inquiry type, and message so the right training, partnership, or consulting path can be reviewed.
            </p>
          </div>
          <div>
            {faqItems.map((item) => (
              <FaqItem key={item.question} item={item} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
